import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tab, Tabs } from '@mui/material';
import { VOICE_LIBRARY } from '@src/constants/voice';
import actions from '@src/redux/actions';
import { COLOR } from '@src/styles/color';
import { FAVOURITE_VOICES } from '@src/constants/voiceLibrary';
import { StyledVoiceFilter } from './index.styled';

const TabsTypeVoice = ({ handleChangeVoiceOwnership }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { filterVoice } = useSelector((state) => state.voice);
  const voiceOwnershipFilter = filterVoice?.voiceOwnership;

  const handleChangeVoiceOwnershipTabs = (_, value) => {
    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        voiceOwnership: value,
      }),
    );
    handleChangeVoiceOwnership(value);
  };

  return (
    <StyledVoiceFilter>
      <Tabs
        value={voiceOwnershipFilter}
        onChange={handleChangeVoiceOwnershipTabs}
        indicatorColor={COLOR.colorGrayV2}
        textColor={COLOR.descriptionGray}
      >
        {[
          ...VOICE_LIBRARY.filter((item) => item.value !== 'PERSONAL'),
          ...VOICE_LIBRARY.filter((item) => item.value === 'PERSONAL'),
          ...[{ label: FAVOURITE_VOICES, value: FAVOURITE_VOICES }],
        ].map((item) => (
          <Tab
            key={item.value}
            value={item.value}
            label={t(item.label)}
            className="filter-tab"
          />
        ))}
      </Tabs>
    </StyledVoiceFilter>
  );
};

export default TabsTypeVoice;
